import { ENV } from '@hcs/webapps';

export const useHcsDevToolsEnabled = () => {
  const localStorageSet = localStorage.getItem('canary-tools') === 'true';
  return {
    data:
      // On by default for HC users in lower envs
      ENV !== 'prod' || localStorageSet,
  };
};
